import {computed, inject, Injectable} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {PluginService} from '../../../../api';
import {PluginSelect} from '../../../../api/models';
import {QueryKey} from '../../../constants/query-key';

@Injectable({providedIn: 'root'})
export class PluginStore {
  private readonly pluginService = inject(PluginService);

  private readonly pluginsQuery = injectQuery(() => ({
    queryKey: [QueryKey.PLUGIN_SELECT],
    queryFn: () => lastValueFrom(this.pluginService.getPluginSelect()),
  }));

  plugins = computed<PluginSelect[]>(() => this.pluginsQuery.data()?.plugins ?? []);
  isDataLoading = computed(() => this.pluginsQuery.isLoading());
}
